// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__8_Imi","alertIcon":"ConfirmModal_alertIcon__1g_yl"};